module.exports = __webpack_public_path__ + "img/stop.fee22af9.svg";